import styled from 'styled-components';
import { withQuery } from '@panel/commons/core/themev2';
import loader from '@panel/commons/assets/icons/loader.gif';
import loaderUBPE from '@panel/commons/assets/icons/loader-urbania.gif';
import { site } from '@panel/commons/helpers';

const loaderLogo = site.id !== 'UBPE' ? loader : loaderUBPE;

const DisabledOverlay = styled.div`
  position: fixed;
  display: block;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(256, 256, 256, 0.6);
  border-radius: 8px;
  background-image: url(${loaderLogo});
  background-repeat: no-repeat;
  background-size: 100px;
  background-position: center;
`;

const Container = styled.div`
  display: block;
  width: 100%;
  padding: ${props => (!props.savedFromModal ? '0px 67px' : '0px')};
  margin-top: 40px;
  white-space: normal;
  min-height: 692px;
  font-family: 'Hind';
  ${withQuery.md.down()} {
    padding: 0px 30px;
    margin-top: 0px;
    min-height: auto;
  }
  ${withQuery.sm.down()} {
    padding: 0px 30px;
    margin-top: 0px;
  }
  ${withQuery.xs.down()} {
    padding: 0px 10px;
  }
  ${withQuery.xxs.down()} {
    padding: 0px;
  }
  overflow-x: hidden;
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1440px;
  margin: 0px auto;
  white-space: normal;
  ${withQuery.lg.down()} {
    width: auto;
  }
  ${withQuery.sm.down()} {
    margin: 0px auto;
  }
`;

const Aside = styled.div`
  flex: 0 1 20%;
`;

const ModuleContainer = styled.div`
  flex: 0 1 75%;
  max-width: 75%;
  margin: 0px auto;
  ${withQuery.lg.down()} {
    max-width: 100%;
    padding: 0px 0px 0px 110px;
  }
  ${withQuery.md.down()} {
    padding: 0px;
    margin: 0px;
    flex: none;
  }
  ${withQuery.xxs.down()} {
    padding: 0px;
    -webkit-flex: none;
    flex: none;
  }
`;

export { Container, Wrapper, Aside, ModuleContainer, DisabledOverlay };
